import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgClass } from '@angular/common';

interface MultiCheckboxOption {
  value: any;
  label: string;
  disabled?: boolean;
}

interface MultiCheckboxOptionInner extends MultiCheckboxOption {
  selected: boolean;
}

export type MultiCheckboxOptions = MultiCheckboxOption[];

@Component({
    selector: 'app-multi-checkbox',
    templateUrl: './multi-checkbox.component.html',
    styleUrls: ['./multi-checkbox.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: MultiCheckboxComponent,
            multi: true
        }
    ],
    imports: [NgClass]
})
export class MultiCheckboxComponent implements OnInit, ControlValueAccessor {

  _innerOptions: MultiCheckboxOptionInner[] = [];

  private _value: any[] = [];

  @HostBinding('class.with-grid') @Input() withGrid = false;

  @Input() set options(opts: MultiCheckboxOptions) {
    this._innerOptions = opts.map(opt => ({
      ...opt,
      selected: this._isSelected(opt)
    }));
  }

  public disabled: boolean;

  private _onChanged = _ => {
  };
  private _onTouched = _ => {
  };

  constructor() {
  }

  ngOnInit(): void {
  }

  registerOnChange(fn: any): void {
    this._onChanged = fn;
  }

  registerOnTouched(fn: any): void {
    this._onTouched = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

  writeValue(obj: any): void {
    this._value = obj || [];

    this._innerOptions = this._innerOptions.map(opt => ({
      ...opt,
      selected: this._isSelected(opt)
    }));
  }

  toggle(option: MultiCheckboxOptionInner): void {
    if (option.disabled || this.disabled) {
      return;
    }

    const selected = this._isSelected(option);

    if (selected) {
      this._value = this._value.filter(value => value !== option.value);
      option.selected = false;
    } else {
      this._value = [...this._value, option.value];
      option.selected = true;
    }

    this._onChanged(this._value);
  }

  private _isSelected(option: MultiCheckboxOption): boolean {
    return this._value.includes(option.value);
  }

}
